import { createAction } from '@reduxjs/toolkit';

export const publishSelected = createAction('integration/publishSelected');
export const cancel = createAction('integration/cancel');
